import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { SFMedia, SFCategory, Localized } from "@robe/core-types";

export interface SFProductObject {
  contentId: number;
  contentTitle: Localized;
}

export interface GetSupportPageDataResponse {
  featuredMedia: Localized<SFMedia[]>;
  supportCategories: SFCategory[];
  productInfos: SFProductObject[];
}

export const getSupportPageData = (core: XcoreCore): BaseApiRequest<GetSupportPageDataResponse> =>
  core.fetch("/api/support-files/support-page-data").then((res) => res.json());
